import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var Dnd = require('./dnd'),
  AppError = require('./../utils/appError');
var Version = require('../component/baseUI/version');
const imgRALogo = require("../../../img/logo_RA.png");

/**
 * Base page layout
 * @prop {bool}useDragAndDrop render layout with drag and drop context
 */
exports.baseLayout = React.createClass({

  propTypes: {
    useDragAndDrop: PropTypes.bool,
    dragAndDropContextShouldUpdateFn: PropTypes.func,
    className: PropTypes.string
  },

  render: function () {
    var { dragAndDropContextShouldUpdateFn } = this.props;
    var layout = (
      <div id="main" role="main">
        <div id="content" className={this.props.className}>
          {this.props.children}
        </div>
      </div>
    );

    var className = classNames('main-content', this.props.className);

    return this.props.useDragAndDrop
      ? (<Dnd.DndContext className={className} shouldUpdateFn={dragAndDropContextShouldUpdateFn}>{layout}</Dnd.DndContext>)
      : (<div className={className}>{layout}</div>);
  }
});


exports.layoutHeader = React.createClass({
  render: function () {
    return (<div className={classNames('row', this.props.className)}>
      <div className="col-xs-12">
        <h1 className="page-title txt-color-blueDark"><i
          className="fa-fw fa fa-home"></i>{this.props.children}</h1>
      </div>
    </div>);
  }
});


exports.errorLayout = React.createClass({

  PropTypes: {
    error: PropTypes.instanceOf(AppError).isRequired,
    hideCode: PropTypes.bool
  },

  getDefaultProps(){
    return {
      error: new AppError(),
      hideCode: false
    }
  },

  render: function () {
    var {error, hideCode} = this.props;

    if (!error) error = new AppError();

    return (
      <div
        className={classNames(
          'error-box',
          { [`error-box--${error.errorCode}`]: error.errorCode }
        )}>
        <div>
          <h1
            display-if={!hideCode}
            className="error-title">{error.errorCode}</h1>
          <h2>{error.errorTitle}</h2>
          <p className="error-description">{error.errorMessage}</p>
        </div>
      </div>
    );
  }
});


exports.fullPageLayout = (props) => (
  <div {...props} className={(props.className || "") + " smart-style-6"}/> );
exports.fullPageLayoutHeader = (props) => (
  <div id="header" {...props}><Version/>{props.children}</div> );

exports.fullPageLayoutLogo = (props) => (
  <div id="logo-group">
    <img src={imgRALogo} alt="Reading Assessment"
         className="logo-image"/>
  </div>
);
exports.fullPageLayoutContent = (props) => (
  <div id="main" role="main">
    <div id="content" className="container">
      <div className="row">
        {props.children}
      </div>
    </div>
  </div>);
